import React from 'react';
import { ModalInfo } from './ModalInfo';

type IModalLink = {
  orden: number;
  titulo?: string;
  mensaje?: string;
};

type ModalMessageProps = {
  show: boolean;
  entity?: IModalLink;
  onClose?: () => void;
};

export const ModalMessage = (props: ModalMessageProps) => {
  const msg = props.entity?.mensaje ?? '';

  return (
    <ModalInfo show={props.show} title={props?.entity?.titulo} closable={true} onClose={props?.onClose} showCloseButton={true} color="secondary.1">
      <p dangerouslySetInnerHTML={{ __html: msg }} />
    </ModalInfo>
  );
};

ModalMessage.displayName = 'ModalMessage';
